import { render } from "./footerPage.vue?vue&type=template&id=7da9bed4&scoped=true"
import script from "./footerPage.vue?vue&type=script&lang=ts"
export * from "./footerPage.vue?vue&type=script&lang=ts"

import "./footerPage.vue?vue&type=style&index=0&id=7da9bed4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7da9bed4"

export default script